export const Config = {
    graphQlApi: '',
    authApi: '',
    themeUrl: '',
    configUrl: '',
};
export const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['clean'],
];
//# sourceMappingURL=config.js.map